// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__MF+lc","show":"LoadingOverlay_show__jd1+l","text":"LoadingOverlay_text__CCRmW"};